import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'
import { Form } from 'components/shared/Form/Form'
import { OutcomeDescription } from 'components/shared/OutcomeDescription/OutcomeDescription'
import { DefaultDescription } from './common/DefaultDescription/DefaultDescription'
import { useInterdependantFields } from './hooks'
import {
  PRODUCTIVITY_FIELD,
  SICKNESS_ABSENCE_FIELD,
  NO_PRIORITY_FIELD,
  TURNOVER_FIELD,
  getFields,
} from './model'

import styles from './PrioritisedOutcome.module.scss'

export const PrioritisedOutcome = ({ control, language, setValue, watch }) => {
  const noPriority = watch(NO_PRIORITY_FIELD)
  const absence = watch(SICKNESS_ABSENCE_FIELD)
  const productivity = watch(PRODUCTIVITY_FIELD)
  const turnover = watch(TURNOVER_FIELD)

  const fields = getFields(language)

  const getTitle = value =>
    Object.entries(fields).find(field => field[1].name === value)[0]

  const activeOutcome = [
    {
      isActive: turnover,
      title: getTitle('turnover'),
    },
    {
      isActive: absence,
      title: getTitle('absence'),
    },
    {
      isActive: productivity,
      title: getTitle('productivity'),
    },
  ].find(({ isActive }) => isActive)?.title

  useInterdependantFields(
    { absence, productivity, turnover, noPriority },
    setValue,
  )

  return (
    <Box className={styles.outcome}>
      <Box className={styles.fields} direction="column">
        <div className={styles.title}>
          {t`What do you want the algorithm to prioritize for this position?`}
        </div>
        <Form.Field
          className={styles.field}
          field="radio"
          label={t`No priority`}
          name={NO_PRIORITY_FIELD}
          {...{ control }}
        />
        <div
          className={styles.description}
        >{t`Are all factors of equal importance?`}</div>
        <Form.Field
          className={styles.field}
          field="radio"
          label={t`Low turnover`}
          name={TURNOVER_FIELD}
          {...{ control }}
        />
        <div
          className={styles.description}
        >{t`Is it important for your business to secure employees who stay in the job for a long time?`}</div>
        <Form.Field
          className={styles.field}
          field="radio"
          label={t`High productivity`}
          name={PRODUCTIVITY_FIELD}
          {...{ control }}
        />
        <div
          className={styles.description}
        >{t`Is high productivity an important goal for your business?`}</div>
        <Form.Field
          className={styles.field}
          field="radio"
          label={t`Low sickness absence`}
          name={SICKNESS_ABSENCE_FIELD}
          {...{ control }}
        />
        <div
          className={styles.description}
        >{t`Is reducing sick leave important for your business?`}</div>
      </Box>
      <aside className={styles.aside}>
        <DetailsCard
          title={activeOutcome ? activeOutcome : t`Prioritised Outcome`}
          hasDefaultState
        >
          {activeOutcome ? (
            <OutcomeDescription outcomes={fields[activeOutcome]?.description} />
          ) : (
            <DefaultDescription />
          )}
        </DetailsCard>
      </aside>
    </Box>
  )
}
